import { GrFormClose } from "react-icons/gr";
import Button from "../../Shared/Button/Button";

const Modal = () => {
  return (
    <div className="absolute top-1/2 left-1/2 flex -translate-x-1/2 -translate-y-1/2 flex-col items-center justify-center bg-white px-10 pt-8 pb-6">
      <p className="mb-2.5 font-pop text-xs font-semibold text-blue">
        This Listing Has Expired
      </p>
      <Button text="Relist Ad" variant="primary" />
      <p className="mt-2 cursor-pointer font-pop text-[10px] font-medium">
        Relist Without Extras
      </p>
      <GrFormClose className="absolute top-1 right-1 h-5 w-5 cursor-pointer" />
    </div>
  );
};

export default Modal;
